<template>
  <v-dialog v-model="modalAdicionarModelo" width="800" height="600">
    <v-card class="mx-auto">
      <v-toolbar flat dark color="success">
        <v-toolbar-title>
          <v-icon>mdi mdi-content-save-check</v-icon>
          Adicionar Modelo
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="fecharModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-row>
          <v-col cols="12" xs="12" md="4">
            <v-text-field v-model="modelo.tipoModelo" label="Tipo do modelo" outlined dense :disabled="true">
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" md="8">
            <soi-input v-model="modelo.nome" append-icon="mdi-magnify" label="Titulo do modelo">
            </soi-input>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end mt-3">
        <v-row justify="end">
          <v-btn color="error" @click="fecharModal" class="mr-2">
            <v-icon>mdi-cancel</v-icon>Cancelar</v-btn>
          <v-btn color="success" class="mr-2" :disabled="modelo.nome.length === 0 || carregando" @click="salvar"
            :loading="carregando">
            <v-icon left>$saveIcon</v-icon> Salvar
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import { ModelosService } from '../../services/ModelosService';
import { MensagemMixin } from '../../helpers/MensagemHelper';
import Modelos from '../../models/modelos/Modelos';

export default Vue.extend({
  name: 'soi-adicionar-modelo',
  props: {
    tipoModeloAtivo: {
      type: String,
      required: true,
    },
    descricaoModelo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modalAdicionarModelo: false,
      carregando: false,
      modelo: new Modelos(),
      modelosService: new ModelosService(),
    };
  },
  mounted() {
    this.modelo.tipoModelo = this.tipoModeloAtivo;
  },
  methods: {
    abrirModalAdicionarModelo() {
      this.modalAdicionarModelo = true;
      this.modelo.nome = '';
    },
    fecharModal() {
      this.modalAdicionarModelo = false;
    },
    async salvar() {
      try {
        this.carregando = true;
        this.modelo.descricao = this.descricaoModelo;
        const _resposta = await this.modelosService.Post(this.modelo);
        MensagemMixin(
          3000,
          'success',
          'Modelo cadastrado com sucesso.',
        );
        this.modalAdicionarModelo = false;
        this.$emit('modeloCadastrado');
      } catch (error) {
        MensagemMixin(3000, 'error', error);
      } finally {
        this.carregando = false;
      }
    },
  },
});
</script>
